module.exports = __webpack_public_path__ + "img/11.01d64ae6.jpg";